@import (reference) '../../../../constants/spacing.module.less';

.breadcrumb {
  padding: 10px @space-16;
  background-color: var(--gray-F9FAFB);
  border-bottom: 1px solid var(--grey-400);
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
}

.link {
  color: var(--blue-006FBB);
  text-decoration: none;
}

.breadcrumb-font {
  font-size: 16px;
}
